// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".collapse-content[data-v-4017cb52]{overflow:hidden;transition:height .3s ease-out}.filter-count-badge[data-v-4017cb52]{--tw-text-opacity:1;align-items:center;color:#f1832f;color:rgb(241 131 47/var(--tw-text-opacity));display:flex;font-size:.875rem;font-weight:700;justify-content:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
